import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hashtag'
})
export class HashtagPipe implements PipeTransform {

  transform(message: string, ...args: any[]): string {
    return `#${message}`;
  }

}
